/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientShellComponent } from './client-shell.component';
import { NavigationBtnPanelComponent } from './navigation-btn-panel/navigation-btn-panel.component';
import { ProjectSharedModule } from 'src/app/project/project-shared/project-shared.module';
import { UserRoleModule } from '../auth/directives/user-role.module';
import { RouterModule } from '@angular/router';
import { TopHeaderPanelComponent } from './top-header-panel/top-header-panel.component';


@NgModule({
  imports: [
    CommonModule,
    ProjectSharedModule,
    UserRoleModule,
    RouterModule
  ],
  declarations: [ClientShellComponent, NavigationBtnPanelComponent, TopHeaderPanelComponent],
  exports:[ClientShellComponent]
})
export class ClientShellModule { }
